import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { func, string } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { isEmail } from 'utils/validate'
import { STATE_FETCHING, STATE_DONE } from 'constants/stateTypes'
import { Input } from 'components/FormElements'
import ActionButton from 'components/uiElements/ActionButton'

require('./RecoverAccount.scss')

const RecoverAccount = ({ triggerPasswordReset, triggerPasswordResetStatus }) => {
    const [email, setEmail] = useState('')
    const submitDisabled = triggerPasswordResetStatus === STATE_FETCHING || !isEmail(email)
    let content = null
    const { t } = useTranslation()
    switch (triggerPasswordResetStatus) {
        case STATE_DONE:
            content = (
                <div className="RecoverAccount">
                    <h2>{t('login.check email')}</h2>
                    <p>{t('login.click link')}</p>
                    <img src={`${ASSET_BUCKET}/graphics/emailSent.svg`} alt={t('login.email sent')} />
                </div>
            )
            break
        default:
            content = (
                <div className="RecoverAccount">
                    <h2>{t('login.forgot password')}</h2>
                    <p>{t('login.enter email')}</p>
                    <Input
                        type="text"
                        placeholder={t('common.email address')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        name="email"
                    />
                    <ActionButton onClick={() => triggerPasswordReset(email)} disabled={submitDisabled}>
                        {t('login.continue')}
                    </ActionButton>
                    <Link to="/login" className="goBack">
                        {t('login.back to login')}
                    </Link>
                </div>
            )
    }

    return content
}

RecoverAccount.propTypes = {
    triggerPasswordReset: func.isRequired,
    triggerPasswordResetStatus: string.isRequired,
}

export default RecoverAccount
